const Row = (props) => {
  const {
    flexDirection = 'row',
    alignItems = 'flex-start',
    justifyContent = 'flex-start',
    flexWrap = 'none',
    gap = 10,
    style = {},
    className = '',
    children
  } = props;

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection,
        alignItems,
        justifyContent,
        flexWrap,
        gap,
        ...style
      }}
    >
      {children}
    </div>
  );
};

export default Row;